import { Flex } from '@banhala/ui-kit';
import { type ReactNode } from 'react';
import type { SetListHeight } from '../../hooks/useListHeight';
import { noop } from 'es-toolkit/compat';

type RenderItemWrapperProps = {
  children: ReactNode;
  setListHeight: SetListHeight;
  index: number;
  title: string;
};

export const RenderItemWrapper = ({
  children,
  setListHeight,
  index,
  title,
}: RenderItemWrapperProps) => {
  return (
    <Flex
      onPress={noop}
      onLayout={e => {
        setListHeight({ height: e.nativeEvent.layout.height, index, title });
      }}
      padding={{ bottom: 32 }}
    >
      {children}
    </Flex>
  );
};
